<template>
  <div style="width: 100%;height: 100%;">
    <div style="position: fixed; width: 100%;height: 100%;z-index: 100" v-if="trackSearch" @click="clearSearch"></div>
      <track-search v-if="trackSearch" id="search" @getTrackNum="getTrackNum"></track-search>

    <div class="demo-split">
      <Split v-model="split2" mode="vertical" @on-move-end="onVehicleInfoSplitMoveEnd">
        <div slot="top" class="demo-split-pane"style="width: 100%;height: 100%;">

<!--          &lt;!&ndash;  地图层  &ndash;&gt;-->
<!--      <div id="map" style="width: 100%;height: 100%;" @click="clearSearch">-->

<!--      </div>-->
<b-dmap ref="bdMapRef" :locateHistorys="locateHistorys" :trips="trips"></b-dmap>



    <!--    车辆选择组件     -->
<!--    <div style="position: relative;top: -40px">-->
<!--      <div-->
<!--        style="position: relative;left:5%;top:50%;z-index: 999;background-color: #f8f8f9;width: 254px;height: 23.99px;border-radius:5px;box-shadow:0 2px 12px 0 rgba(0,0,0,.3);">-->
<!--        <div style="position:relative" :style="{top: openselectcartop + 'px'}">-->
<!--          <List style="background-color: #f8f8f9;" border size="small" v-if="openselectcar">-->
<!--            <ListItem><p>车辆：</p>-->
<!--              <AutoComplete-->
<!--                size="small"-->
<!--                @on-change="changedata3"-->
<!--                clearable-->
<!--                v-model="registrationNum"-->
<!--                :data="data3"-->
<!--                :filter-method="filterMethod"-->
<!--                placeholder="车牌号"-->
<!--                style="width: 115px; margin-right: 5px;">-->
<!--              </AutoComplete>-->
<!--              &lt;!&ndash;          <Input size="small" clearable v-model="registrationNum" placeholder="车牌号"&ndash;&gt;-->
<!--              &lt;!&ndash;                                      style="width: 90px;margin-right: 5px"/>&ndash;&gt;-->
<!--              <Button size="small" type="primary" @click="showSearch">高级查询</Button>-->
<!--            </ListItem>-->
<!--            <ListItem><p>开始时间：</p>-->
<!--              <DatePicker size="small" v-model="startDatetime" ref="producetime" @on-change="showTimePanel('producetime')"-->
<!--                          :start-date="new Date()" type="datetime" placeholder="开始时间" style="width: 160px"></DatePicker>-->
<!--            </ListItem>-->
<!--            &lt;!&ndash;         <ListItem><p>结束时间：</p>&ndash;&gt;-->
<!--            &lt;!&ndash;          <DatePicker size="small" v-model="endDatetime" ref="producetime1" @on-change="showTimePanel1('producetime1')"&ndash;&gt;-->
<!--            &lt;!&ndash;                      :start-date="new Date()" type="datetime" placeholder="结束时间" style="width: 160px"></DatePicker>&ndash;&gt;-->
<!--            &lt;!&ndash;         </ListItem>&ndash;&gt;-->

<!--            <ListItem><p>结束时间：</p>-->
<!--              <DatePicker size="small" type="datetime" v-model="endDatetime" ref="producetime1" @on-change="showTimePanel1('producetime1')"-->
<!--                          :start-date="new Date()" placeholder="结束时间" style="width: 160px"></DatePicker>-->
<!--            </ListItem>-->

<!--            &lt;!&ndash;         <ListItem>&ndash;&gt;-->
<!--            &lt;!&ndash;          <Checkbox style="line-height: 12px;" @on-change="stopCheck" v-model="stopChecked">停车时长(分) ></Checkbox>&ndash;&gt;-->
<!--            &lt;!&ndash;          <Input class="check-input" style="width: 40px;margin-right: 30px;margin-bottom: 2.5px;"&ndash;&gt;-->
<!--            &lt;!&ndash;                 v-model="stopDateTimeCheck"></Input>&ndash;&gt;-->
<!--            &lt;!&ndash;         </ListItem>&ndash;&gt;-->
<!--            &lt;!&ndash;         <ListItem>&ndash;&gt;-->
<!--            &lt;!&ndash;          <Checkbox style="line-height: 12px;" @on-change="travelCheck" v-model="travelChecked">行驶时长(分) ></Checkbox>&ndash;&gt;-->
<!--            &lt;!&ndash;          <Input class="check-input" style="width: 40px;margin-right: 30px;margin-bottom: 2.5px;"&ndash;&gt;-->
<!--            &lt;!&ndash;                 v-model="travelDateTimeCheck"></Input>&ndash;&gt;-->
<!--            &lt;!&ndash;         </ListItem>&ndash;&gt;-->
<!--            <ListItem>-->
<!--              <Button size="small" type="primary" :disabled="onSearchClickdisabled" style="margin-right: 20px;"-->
<!--                      @click="tomap">查询-->
<!--              </Button>-->
<!--            </ListItem>-->
<!--          </List>-->
<!--          <Row>-->

<!--            &lt;!&ndash;        <Input size="small" readonly v-model="registrationNum" placeholder="车牌号" style="width: 230px"/>&ndash;&gt;-->
<!--            <AutoComplete-->
<!--              size="small"-->
<!--              @on-change="changedata3"-->
<!--              clearable-->
<!--              v-model="registrationNum"-->
<!--              :data="data3"-->
<!--              :filter-method="filterMethod"-->
<!--              placeholder="车牌号"-->
<!--              style="width: 190px;">-->
<!--            </AutoComplete>-->
<!--            <Button size="small" type="primary" :disabled="onSearchClickdisabled"-->
<!--                    @click="tomap">查询</Button>-->
<!--            <Button v-if="!openselectcar" size="small" icon="ios-arrow-up" @click="showbox"></Button>-->
<!--            <Button v-if="openselectcar" size="small" icon="ios-arrow-down" @click="showbox"></Button>-->
<!--          </Row>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

          <vehicle-choice-model ref="vehiclechoicemodel" @getlocateHistorys="getlocateHistorys" @showSearch="showSearch" :registrationNum="registrationNum" :onSearchClickdisabled="onSearchClickdisabled"></vehicle-choice-model>

          <play-control ref="playcontrol" @setHighlightRow="setHighlightRow" @scrollToRow="scrollToRow" @drawCar="drawCar"></play-control>
<div>

          <parking-information ref="parkinginformation" :trips="trips" @toStopLocation="toStopLocation"></parking-information>
</div>

          <!--  加载蒙层  -->
    <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                                 align-items: center;
                                 justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="mapLoadding">
      <Spin size="large"></Spin>
      <h6 style="color:#2d8cf0;margin-top:10px;">正在加载轨迹数据...</h6>
    </div>
        </div>
        <div slot="bottom" class="demo-split-pane">
<!--          轨迹数据-->
          <locate-table-model id="bigdataTable" ref="bigdataTable" @onSliderChange="onSliderChange"></locate-table-model>
        </div>
      </Split>
    </div>

<!--    <div style="z-index: 999;    position: absolute;top: 100px;">-->
<!--      <Button type="primary" size="small" style="margin-right: 3px;" @click="onstart">重新开始</Button>-->
<!--      <Button type="primary" size="small" style="margin-right: 3px;" @click="onpauseAni">暂停</Button>-->
<!--      <Button type="primary" size="small" style="margin-right: 3px;" @click="oncontinueAni">继续</Button>-->
<!--    </div>-->

  </div>
</template>

<script>

  import Vue from 'vue'
  import store from '../../store'
  import { GPS } from '@/libs/positonUtils'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import TrackSearch from '@/components/track-search/track-search'
  import moment from 'moment'

  import BDmap from '@/view/history/components/bd-map'
  import PlayControl from '@/view/history/components/play-control'
  import ParkingInformation from '@/view/history/components/parking-information'
  import VehicleChoiceModel from '@/view/history/components/vehicle-choice-model'

  import LocateTableModel from '@/view/history/components/locate-table-model'

  export default {
    name: "locateplaybackBD",
    components: {
      TrackSearch,
      BDmap,
      VehicleChoiceModel,
      PlayControl,
      ParkingInformation,
      LocateTableModel,
    },
    data() {
      return {
        split2: 0.7,

        BDmap: null,
        trackAni: null,


        locateHistorys:null,
        trips:null,

        mapLoadding: false,

        /*车辆选择*/
        openselectcartop: 0,
        openselectcar: false,
        startDatetime: '',
        endDatetime: '',
        onSearchClickdisabled: true,

        registrationNum: '',
        data3: [],

        trackSearch: false,
      }
    },
    methods: {

// /*车辆选择*/
//       showbox () {
//         if (this.openselectcar == true) {
//           this.openselectcar = false
//           this.openselectcartop = 0
//         } else {
//           this.openselectcar = true
//           this.openselectcartop = -165
//         }
//       },
//
      clearSearch () {
        // this. trackSearch = false
        this.trackSearch = false
      },
      showSearch () {
        this.trackSearch = true
      },
//
//       changedata3 () {
//         let t = null
//         if (t !== null){
//           clearTimeout(t)
//         }
//         t = setTimeout(()=>{
//             console.log(this.registrationNum)
//             // this.data3 = []
//             if (!this.registrationNum || this.registrationNum === '') {
//             } else {
//               store.dispatch('VehicleInfoServ_SearchByName', {
//                 params: {
//                   name:this.registrationNum
//                 },
//                 urlparams: null
//               }).then(res => {
//                 this.data3 = []
//                 this.list = res.data
//
//                 let result = []
//                 for (let i = 0; i < this.list.length; i++) {
//                   let str = this.list[i].registrationNum === null ? this.list[i].vin : this.list[i].registrationNum
//                   if (str.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
//                     result.push(str)
//                   }
//
//                   if (this.list[i].customName) {
//                     let str1 = this.list[i].customName
//                     if (str1.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
//                       result.push(str1)
//                     }
//                   }
//                 }
//                 let length = result.length > 10 ? 10 : result.length
//                 for (let i = 0; i < length; i++) {
//                   this.data3.push(result[i])
//                 }
//               }).catch(err => {
//                 this.$Message.error(err)
//               })
//             }
//           }
//           ,2000)
//       },
//
//       filterMethod () {
//         this.onSearchClickdisabled = false
//
//         return true
//       },

      // selectvehicle(e){
      //   console.log(e)
      //   store.dispatch('VehicleInfoServ_SearchByName', {
      //     params: {
      //       name:e
      //     },
      //     urlparams: null
      //   }).then(res => {
      //     let VehicleInfoByTerminalNum = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(res.data[0].positioningDeviceInfos[0].terminalNum)
      //     console.log(VehicleInfoByTerminalNum)
      //     if (VehicleInfoByTerminalNum){
      //       console.log('已订阅')
      //       console.log(this.checkedVehicleInfos)
      //       if (this.checkedVehicleInfos.length >0){
      //         this.checkedVehicleInfos.forEach(item =>{
      //           console.log(item)
      //           if (item.positioningDeviceInfos[0].terminalNum == VehicleInfoByTerminalNum.positioningDeviceInfos[0].terminalNum){
      //
      //             let positioningDeviceInfos = []
      //             positioningDeviceInfos.push(VehicleInfoByTerminalNum.positioningDeviceInfos[0])
      //             this.onvehicleinfo(positioningDeviceInfos)
      //           }else{
      //             console.log(item)
      //
      //             this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
      //             let newvehiclelist = []
      //             newvehiclelist.push(VehicleInfoByTerminalNum)
      //             this.vehicleDymaicManager.subscribeDymaicData(newvehiclelist, true)
      //           }
      //         })
      //       } else {
      //         this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
      //         this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
      //
      //       }
      //       // for (let i = 0; i < this.checkedVehicleInfos.length; i++) {
      //       //   console.log(this.checkedVehicleInfos[i])
      //       //   if (this.checkedVehicleInfos[i].positioningDeviceInfos[0].terminalNum == VehicleInfoByTerminalNum.positioningDeviceInfos[0].terminalNum){
      //       // console.log('加载订阅')
      //       //
      //       //   let positioningDeviceInfos = []
      //       //   positioningDeviceInfos.push(VehicleInfoByTerminalNum.positioningDeviceInfos[0])
      //       //   this.onvehicleinfo(positioningDeviceInfos)
      //       // }else{
      //       //   console.log(this.checkedVehicleInfos[i])
      //       //
      //       //   this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
      //       //   let newvehiclelist = []
      //       //   newvehiclelist.push(VehicleInfoByTerminalNum)
      //       //   this.vehicleDymaicManager.subscribeDymaicData(newvehiclelist, true)
      //       // }
      //       // }
      //
      //     }else {
      //       console.log('未订阅')
      //       this.vehicleDymaicManager.putVehicleInfo(res.data)
      //       let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(res.data[0].positioningDeviceInfos[0].terminalNum)
      //       console.log(vehicleInfo)
      //       if (vehicleInfo) {
      //         this.checkedVehicleInfos.push(vehicleInfo)
      //       }
      //       this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
      //     }
      //   }).catch(err=>{
      //     this.$Message.error(err)
      //   })
      // },

/*高级搜索*/
      getTrackNum (registrationNum, terminalNum) {
        console.log(terminalNum)
        this.registrationNum = registrationNum
        this.terminalNum = terminalNum[0].terminalNum
        this.vehicleid = terminalNum[0].vehicleInfoId
        this.trackSearch = false
        if (this.terminalNum != null && this.startDatetime != '' && this.endDatetime != '') {
          this.onSearchClickdisabled = false
        }
      },
//
//       /*时间选择器*/
//       showTimePanel (refName) {
//         /* 此处的onSelectionModeChange方法，就是同点击 选择时间 按钮后触发的方法
//       具体此方法的代码逻辑，可以下载组件源码查看 */
//         this.$refs[refName].onSelectionModeChange('time')
//         if (this.endDatetime != null && this.endDatetime != '' && this.startDatetime > this.endDatetime) {
//           this.$Message.error('请选择正确日期和时间，结束日期不能早于开始日期')
//         } else {
//           if (this.registrationNum != null && this.endDatetime != null && this.endDatetime != '') {
//             this.onSearchClickdisabled = false
//           }
//         }
//       },
//       showTimePanel1 (refName) {
//         /* 此处的onSelectionModeChange方法，就是同点击 选择时间 按钮后触发的方法
//       具体此方法的代码逻辑，可以下载组件源码查看 */
//         this.$refs[refName].onSelectionModeChange('time')
//
//         if (new Date(this.endDatetime).getHours() == 0 && new Date(this.endDatetime).getMinutes() == 0 && new Date(this.endDatetime).getSeconds() == 0) {
//           this.endDatetime = moment(this.endDatetime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
//         }
//
//         if (this.startDatetime != null && this.startDatetime != '' && this.startDatetime > this.endDatetime) {
//           this.$Message.error('请选择正确日期和时间，结束日期不能早于开始日期')
//         } else {
//           if (this.registrationNum != null && this.startDatetime != null && this.startDatetime != '') {
//             this.onSearchClickdisabled = false
//           }
//         }
//       },
//
//       /**
//        * 按时间格式搜索轨迹数据
//        */
//       onSearchClick () {
//         this.mapLoadding = true
//         return new Promise((resolve, reject) => {
//         if ((this.endDatetime - this.startDatetime) > 172799000) {
//           this.$Message.error('时间过长，请选择48小时内')
//           this.mapLoadding = false
//           return
//         }
//
//         // console.log(this.registrationNum)
//         let queryParams = []
//         console.log(this.registrationNum.length)
//         if (this.registrationNum.length > 6) {
//           queryParams.push(genQueryParam('registrationNum', 'EQ', this.registrationNum))
//         } else {
//           queryParams.push(genQueryParam('customName', 'EQ', this.registrationNum))
//         }
//         // queryParams.push(genQueryParam('customName', 'EQ', this.registrationNum))
//         store.dispatch('VehicleInfoServ_GetPage', {
//           params: null,
//           urlparams: {
//             q: queryParams
//           }
//         }).then(res => {
//           if (res.data.content.length > 0) {
//             res.data.content.forEach(item => {
//               if (this.registrationNum.length > 6) {
//                 if (item.registrationNum === this.registrationNum) {
//                   this.terminalNum = item.positioningDeviceInfos[0].terminalNum
//                   this.vehicleid = item.id
//                 }
//               } else {
//                 if (item.customName === this.registrationNum) {
//                   this.terminalNum = item.positioningDeviceInfos[0].terminalNum
//                   this.vehicleid = item.id
//                 }
//               }
//             })
//             // this.terminalNum = res.data.content[0].positioningDeviceInfos[0].terminalNum
//             // this.vehicleid = res.data.content[0].id
//             console.log(this.terminalNum)
//             console.log(this.vehicleid)
//
//             if (this.startDatetime === '' || this.endDatetime === '') {
//               this.startDate = null
//               this.endDate = null
//               this.$Message.error('请选择日期时间')
//               this.mapLoadding = false
//               return
//             }
//             let startDate = this.startDatetime
//             let endDate = this.endDatetime
//             // console.log(this.startDatetime)
//             // console.log(this.endDatetime)
//             // console.log(this.dateFilter[1] - this.dateFilter[0])
//             // if ((this.endDatetime - this.startDatetime) > 172799000) {
//             //   this.$Message.error('时间过长，请选择48小时内')
//             //   this.mapLoadding = false
//             //   return
//             // }
//             this.startDate = new Date(startDate).Format('yyyy-MM-dd hh:mm:ss')
//             this.endDate = new Date(endDate).Format('yyyy-MM-dd hh:mm:ss')
//             // console.log(this.terminalNum)
//             store.dispatch('TripServ_LoadComplexTripsByStartDatetime', {
//               params: {
//                 terminalNum: this.terminalNum,
//                 startDatetime: this.startDate,
//                 endDatetime: this.endDate
//               },
//               urlparams: null
//             }).then(res => {
//               // new promise(() => {
//               //
//               // })
//               if (res.data.locateHistorys.length) {
//                 console.log('传入数据')
//                 this.locateHistorys = res.data.locateHistorys
//                 this.trips = res.data.trips
//                 console.log(this.locateHistorys)
//                 console.log(this.trips)
//                 console.log('开始绘制')
//               //   setTimeout(
//               // this.$refs.bdMapRef.draw()
//               //     ,500)
//               } else {
//                 alert('没有轨迹')
//               }
//               this.mapLoadding = false
//
//               // // console.log(res.data.locateHistorys)
//               // console.log(res.data.trips)
//               // this.drawMarker(res.data.trips)
//               // this.mapLoadding = false
//               //
//               // // this.LoadComplexTripsByStartDatetime()
//               // if (res.data.locateHistorys.length) {
//               //   // this.content = res.data.locateHistorys
//               //   // this.makecurrentPageContent(this.content)
//               //   // this.initPlayControl()
//               //   // console.log(res.data)
//               //   // this.drawTrack(this.content)
//               //   // this.drawStopPOI(res.data.trips)
//               //
//               //   this.drawLine(res.data.locateHistorys)
//               // } else {
//               //   alert('没有轨迹')
//               // }
//             }).catch(err => {
//               // this.locateHistorys = '没有轨迹'
//               // this.trips = '没有轨迹'
//               // this.$refs.bdMapRef.draw()
//               console.log(err)
//               this.mapLoadding = false
//             })
//           }
//         }).catch(err => {
//           console.log(err)
//           this.mapLoadding = false
//         })
//         })
//       },
//
//       /**
//        * 查询数据后传值至组件
//        */
//       tomap(){
//         this.onSearchClick().then(function () {
//           console.log("获取数据结束！");
//           this.$refs.bdMapRef.draw()
//         });
//       },


      getlocateHistorys(locateHistorys,trips, registrationNum){
        console.log(locateHistorys)
        console.log(trips)
        console.log(registrationNum)
        this.locateHistorys = locateHistorys
        this.trips = trips
        this.registrationNum = registrationNum
        this.$refs.bdMapRef.clear()
        this.$refs.bdMapRef.draw(locateHistorys,trips)
        this.$refs.parkinginformation.gettrips(trips)
        this.$refs.playcontrol.initPlayControl(locateHistorys)
        this.$refs.bigdataTable.makecurrentPageContent(locateHistorys, this.registrationNum)
      },

      /**
       * 播放控制器返回方法
       */
      setHighlightRow(e){
        console.log(e)
        this.$refs.bigdataTable.setHighlightRow(e)
      },
      scrollToRow(e){
        console.log(e)
        this.$refs.bigdataTable.scrollToRow(e)
      },
      drawCar(data){
        console.log(data)
        // this.$refs.bdMapRef.clear()
        this.$refs.bdMapRef.drawCar(data)
      },
/**
 * 停车信息框
 */
      toStopLocation(data){
        this.$refs.bdMapRef.toStopLocation(data)
},
      /**
       * 表格组件返回的滑块方法
       */
        onSliderChange(e){
        console.log(e)
        this.$refs.playcontrol.onSliderChange(e)
      },
      /**
       * 分割线移动方法
       * 更改轨迹数据表格高度
       */
      onVehicleInfoSplitMoveEnd(){
        document.getElementById('bigdataTable').style.height = ((document.body.clientHeight - 125 ) * (1-this.split2)) + 'px'
      },
  },
    mounted() {
      // this.creatmap()
      // this.drawLine()

      /*初始化时间*/
      this.startDatetime = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.endDatetime = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')

      this.onVehicleInfoSplitMoveEnd()
    }
  }
</script>

<style scoped>
  .demo-split{
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
</style>
